<template>
    <div>
        <!-- 基本信息 -->
        <div class="model-box">
            <div class="model-box-top">
                <div class="model-box-index">{{ index }}</div>
                <div class="model-box-close" v-if="index > 1" @click="removeHandle">
                    <i class="el-icon-circle-close"></i>
                </div>
            </div>
            <el-form ref="form" :model="form" :rules="computedRules" label-width="85px">
                <div class="model-box-cont">

                    <!-- 境外学历开关（仅在 show_overseas=true 时显示） -->
                    <div class="model-box-cont-item model-box-cont-item-4" v-if="show_overseas">
                        <el-form-item label="院校类别:" style="margin-bottom: 0 !important;">
                            <el-radio-group v-model="form.is_overseas" @change="onOverseasChange">
                                <el-radio :label="0">境内</el-radio>
                                <el-radio :label="1">境外</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>

                    <!-- 境外说明提示（境外时显示） -->
                    <div class="model-box-cont-item model-box-cont-item-4" v-if="show_overseas && form.is_overseas === 1">
                        <div class="overseas-notice">
                            <i class="el-icon-warning" style="color:#E6A23C;margin-right:4px;"></i>
                            境外学历说明：境外学历须通过教育部认证，非公派留学生请从认证院校列表中选择毕业院校。
                        </div>
                    </div>

                    <!-- 公派留学生（境外时显示） -->
                    <div class="model-box-cont-item model-box-cont-item-4" v-if="show_overseas && form.is_overseas === 1">
                        <el-form-item label="公派留学:"  style="margin-bottom: 0 !important;">
                            <el-radio-group v-model="form.is_gov_sponsored" @change="onGovSponsoredChange">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>

                    <!-- 毕业院校（境内/公派：文本输入；非公派境外：远程搜索选择） -->
                    <div class="model-box-cont-item">
                        <!-- 非公派境外：远程搜索选择认证院校 -->
                        <el-form-item label="毕业院校:" prop="school_name" v-if="show_overseas && form.is_overseas === 1 && form.is_gov_sponsored === 0">
                            <el-select
                                v-model="form.school_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入关键字搜索认证院校"
                                :remote-method="remoteSearchSchool"
                                :loading="schoolSearchLoading"
                                size="small"
                                style="width:100%"
                                @change="onSchoolSelect">
                                <el-option
                                    v-for="item in schoolOptions"
                                    :key="item.id"
                                    :label="item.schoolName"
                                    :value="item.schoolName">
                                    <span>{{ item.schoolName }}</span>
                                    <span v-if="item.country" style="float:right;color:#8492a6;font-size:12px;">{{ item.country }}</span>
                                </el-option>
                            </el-select>
                            <div style="margin-top:4px;line-height: 1;">
                                <el-link type="primary" :underline="false" @click="showAllSchoolsDialog = true" style="font-size:12px;">
                                    查看全部认证院校 <i class="el-icon-arrow-right"></i>
                                </el-link>
                            </div>
                        </el-form-item>
                        <!-- 境内 或 公派留学生：普通文本输入 -->
                        <el-form-item label="毕业院校:" prop="school_name" v-else>
                            <el-input v-model="form.school_name" size="small"></el-input>
                        </el-form-item>
                    </div>

                    <div class="model-box-cont-item">
                        <el-form-item label="专业:" prop="specialty">
                            <el-input v-model="form.specialty" size="small"></el-input>
                        </el-form-item>
                    </div>
                    <div class="model-box-cont-item">
                        <el-form-item label="主修课程:" prop="main_course">
                            <el-input v-model="form.main_course" size="small"></el-input>
                        </el-form-item>
                    </div>
                    <div class="model-box-cont-item">
                        <el-form-item :label=" degree_cert ? '获得学位时间:' : '毕业时间:'" prop="graduation_time">
                            <el-date-picker v-model="form.graduation_time"  value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" size="small" style="width: 180px;" />
                        </el-form-item>
                    </div>
                    <div class="model-box-cont-item" v-if="degree_cert">
                        <el-form-item label="学位证书:" prop="degree_img">
                            <div class="img-box">
                                <upload-img ref="degree_img" filed="degree_img" isSingle
                                    :callFun="sendUpload" accept-file :file-size="10"></upload-img>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="model-box-cont-item">
                        <el-form-item label="毕业证书:" prop="graduation_img">
                            <div class="img-box">
                                <upload-img ref="graduation_img" filed="graduation_img" isSingle
                                    :callFun="sendUpload" accept-file :file-size="10"></upload-img>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="model-box-cont-item" v-if="chsi_cert">
                        <el-form-item label="学信网信息页截图" prop="chsi_img">
                            <div class="img-box">
                                <upload-img ref="chsi_img" filed="chsi_img" isSingle :callFun="sendUpload" accept-file :file-size="10"></upload-img>
                            </div>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </div>

        <!-- 查看全部认证院校弹窗 -->
        <el-dialog title="认证境外院校列表" :visible.sync="showAllSchoolsDialog" width="600px" append-to-body>
            <div style="margin-bottom:10px;">
                <el-input v-model="allSchoolsFilter" placeholder="输入关键字过滤" size="small" style="width:240px;" prefix-icon="el-icon-search"/>
                <span style="margin-left:12px;font-size:12px;color:#909399;">双击院校行可快速填入毕业院校</span>
            </div>
            <el-table :data="filteredAllSchools" size="small" max-height="400" @row-dblclick="onSchoolRowDblclick" style="cursor:pointer;">
                <el-table-column label="院校名称" prop="schoolName" min-width="200"/>
                <el-table-column label="国家/地区" prop="country" width="150"/>
            </el-table>
            <div style="text-align:center;margin-top:12px;" v-if="allSchoolsLoading">
                <i class="el-icon-loading"></i> 加载中...
            </div>
            <div slot="footer">
                <el-button @click="showAllSchoolsDialog = false">关 闭</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import { uploadImageFile, searchCertifiedSchools, listAllCertifiedSchools } from "@/api/index.js";
import uploadImg from './uploag_img.vue'
export default {
    components: {
        uploadImg
    },
    props: {
        index: { type: [String, Number], default: '1' },
        filed: { type: String, default: '' },
        degree_cert: {type: Boolean, default: true},
        chsi_cert:{type: Boolean, default: true},
        show_overseas: {type: Boolean, default: false}, // 是否显示境外学历选项（仅研究生/博士且岗位开启时为true）
        form: {
            type: Object, default: () => ({
                school_name: '',
                specialty: '',
                main_course: '',
                graduation_time: '',
                graduation_img: '',
                degree_img: '',
                chsi_img: '',
                is_overseas: 0,
                is_gov_sponsored: 0,
            })
        }
    },
    data() {
        return {
            schoolSearchLoading: false,
            schoolOptions: [],
            showAllSchoolsDialog: false,
            allSchoolsList: [],
            allSchoolsLoading: false,
            allSchoolsFilter: '',
        }
    },
    computed: {
        computedRules() {
            return {
                school_name: [
                    { required: true, message: '请输入学校名称' },
                ],
                specialty: [
                    { required: true, message: '请输入所学专业' },
                ],
                main_course: [
                    { required: true, message: '请输入主修课程' },
                ],
                graduation_time: [
                    { required: true, message: '请选择时间' },
                ],
                graduation_img: [
                    { required: true, message: '请上传毕业证书', trigger: 'change' },
                ],
                degree_img: [
                    { required: true, message: '请上传学位证书', trigger: 'change' },
                ],
                chsi_img: [
                    { required: true, message: '请上传学信网信息截图', trigger: 'change' },
                ],
            }
        },
        filteredAllSchools() {
            if (!this.allSchoolsFilter) return this.allSchoolsList;
            const kw = this.allSchoolsFilter.toLowerCase();
            return this.allSchoolsList.filter(s =>
                (s.schoolName && s.schoolName.toLowerCase().includes(kw)) ||
                (s.country && s.country.toLowerCase().includes(kw))
            );
        }
    },
    watch: {
        showAllSchoolsDialog(val) {
            if (val && this.allSchoolsList.length === 0) {
                this.loadAllSchools();
            }
        }
    },
    beforeDestroy() {
        this.$refs.form.resetFields();
    },
    methods: {
        onOverseasChange(val) {
            if (val === 0) {
                // 切回境内，重置公派和院校
                this.form.is_gov_sponsored = 0;
                this.form.school_name = '';
            }
        },
        onGovSponsoredChange() {
            // 切换公派状态时清空学校
            this.form.school_name = '';
            this.schoolOptions = [];
        },
        onSchoolSelect(val) {
            // 选择认证院校后更新 form.school_name（el-select value已绑定，此处用于扩展处理）
        },
        onSchoolRowDblclick(row) {
            this.form.school_name = row.schoolName;
            this.showAllSchoolsDialog = false;
        },
        remoteSearchSchool(query) {
            if (!query) {
                this.schoolOptions = [];
                return;
            }
            this.schoolSearchLoading = true;
            searchCertifiedSchools(query).then(res => {
                if (res.code === 200) {
                    this.schoolOptions = res.data || [];
                }
                this.schoolSearchLoading = false;
            }).catch(() => {
                this.schoolSearchLoading = false;
            });
        },
        loadAllSchools() {
            this.allSchoolsLoading = true;
            listAllCertifiedSchools().then(res => {
                if (res.code === 200) {
                    this.allSchoolsList = res.data || [];
                }
                this.allSchoolsLoading = false;
            }).catch(() => {
                this.allSchoolsLoading = false;
            });
        },

        submitCheck() {
            return new Promise((resolve, reject) => {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let copy_form = JSON.parse(JSON.stringify(this.form))
                        resolve(copy_form)
                    } else {
                        reject('还有未填写项')
                    }
                });
            })
        },

        removeHandle() {
            this.$emit('removeCall', { index: this.index, filed_str: this.filed })
        },

        sendUpload(file, filed_str) {
            let formData = new FormData();
            formData.append('file', file);
            uploadImageFile(formData).then(res => {
                let { code, url, newFileName, msg } = res;
                if (code == 200 && !!url) {
                    let show_pic = {
                        name: newFileName,
                        url: url
                    }
                    this.$refs[filed_str].uploadSuccess([show_pic])
                    this.form[filed_str] = url || ''
                } else {
                    this.$refs[filed_str].uploadSuccess([])
                    this.$message.warning('图片上传失败，请重试;', msg)
                }
            }).catch(err => {
                this.$refs[filed_str].uploadSuccess([])
                this.$message.warning('图片上传失败，请重试;', err)
            })
        },

        updateImageDisplay(filed_str, url) {
            if (this.$refs[filed_str] && url) {
                this.form[filed_str] = url;
                this.$refs[filed_str].uploadSuccess([{
                    name: filed_str === 'graduation_img' ? '毕业证书' :
                          filed_str === 'degree_img' ? '学位证书' :
                          filed_str === 'chsi_img' ? '学信网信息' : '证书照片',
                    url: url
                }]);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.model-box,
.model-box * {
    box-sizing: border-box;
}

.model-box {
    width: auto;
    height: auto;
    overflow: hidden;
    margin: 0 10px 20px 0;
    border-radius: 5px;
    border: 1px dashed #e4e4e4;

    .model-box-top {
        padding: 10px 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .model-box-index {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #e4e4e4;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            color: #000;
        }

        .model-box-close {
            font-size: 20px;

            i {
                color: #c80000;
                cursor: pointer;
            }

        }
    }

    .model-box-cont {
        width: auto;
        height: auto;
        overflow: hidden;

        padding: 10px 10px 0px;

        .model-box-cont-item {
            width: calc(100% / 4);
            display: inline-block;
            padding-right: 10px;

            .img-box {
                //height: 100px;
            }

            .img-list {
                display: flex;
                flex-wrap: wrap;

                .img-box {
                    width: 150px;
                    margin: 0 10px 10px 0;
                }
            }
        }

        .model-box-cont-item-2 {
            width: calc((100% / 4) * 2);
        }

        .model-box-cont-item-3 {
            width: calc((100% / 4) * 3);
        }

        .model-box-cont-item-4 {
            width: calc((100% / 4) * 4);
        }
    }
}

.overseas-notice {
    background: #fdf6ec;
    border: 1px solid #faecd8;
    border-radius: 4px;
    padding: 8px 12px;
    color: #e6a23c;
    font-size: 13px;
    line-height: 1.6;
    margin-bottom: 8px;
}
</style>
